import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type LocalStore = {
  theme: 'auto' | 'dark' | 'light'
  setTheme: (mode: 'auto' | 'dark' | 'light') => void
  getPreferredTheme: () => 'dark' | 'light'
  expandedSidebar: boolean
  setExpandedSidebar: (expanded: boolean) => void
  useNewDashboard: boolean
  setUseNewDashboard: (version: boolean) => void
  lastActiveWorkspaceId?: string
  setLastActiveWorkspaceId: (id: string) => void
  lastActiveBotIds: Record<string, string>
  getLastActiveBotId: (workspaceId?: string) => string | undefined
  setLastActiveWorkspaceAndBotIds: (workspaceId: string, botId: string) => void
  removeLastActiveBotId: (workspaceId: string) => void
}

export const useLocalStore = create<LocalStore>()(
  devtools(
    persist(
      (set, get) => {
        return {
          theme: 'auto',
          preferredTheme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
          setTheme: (mode: 'auto' | 'dark' | 'light') => {
            return set({ theme: mode })
          },
          getPreferredTheme: () => {
            const theme = get().theme

            if (theme === 'auto') {
              return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
            }

            return theme
          },
          expandedSidebar: true,
          setExpandedSidebar: (expanded: boolean) => set({ expandedSidebar: expanded }),
          useNewDashboard: false,
          setUseNewDashboard: (version: boolean) => set({ useNewDashboard: version }),
          lastActiveBotIds: {},
          setLastActiveWorkspaceAndBotIds: (lastActiveWorkspaceId, lastActiveBotId) => {
            set((state) => {
              return {
                ...state,
                lastActiveWorkspaceId,
                lastActiveBotIds: { ...state.lastActiveBotIds, [lastActiveWorkspaceId]: lastActiveBotId },
              }
            })
          },
          removeLastActiveBotId: (workspaceId) => {
            const { lastActiveBotIds } = get()
            set((state) => {
              const { [workspaceId]: removed, ...remainingBotIds } = state.lastActiveBotIds
              return { ...state, lastActiveBotIds: remainingBotIds }
            })
          },
          getLastActiveBotId: (overrideWorkspaceId) => {
            const workspaceId = overrideWorkspaceId ?? get().lastActiveWorkspaceId
            return workspaceId ? get().lastActiveBotIds?.[workspaceId] : undefined
          },
          setLastActiveWorkspaceId: (id) => {
            set((state) => {
              return { ...state, lastActiveWorkspaceId: id }
            })
          },
        }
      },
      {
        name: 'botpress-dashboard',
      }
    )
  )
)
